// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import LogoSpinner from './LogoSpinner';

const PageLoaderMain = ({ logoAnimate, logoFade, logoShow, ...rest }) => (
    <div className="PageLoaderMain workspace-positioner">
        <main className="Main">
            <div className="PageLoadingDisplay">
                <LogoSpinner {...rest} animate={logoAnimate} fadeIn={logoFade} show={logoShow} />
            </div>
        </main>
    </div>
);

PageLoaderMain.propTypes = {
    logoAnimate: PropTypes.bool,
    logoFade: PropTypes.bool,
    logoShow: PropTypes.bool,
};

export default PageLoaderMain;
